import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";
import { GqlMockCall } from "@/gql/lib";
import { GqlCallsKey } from "../demo/gql.resolver";
import { ICONS } from "@/common/icons.map";
import { rand_floor } from "@/fp";

let users: any[];
const info_types_categories: Array<{
  id: string;
  l0_id: string;
  icon: string;
  name: string;
}> = [
  [
    "Financial Information",
    "fd6a3357-4b1f-df40-d9f5-731e35302fe5",
    "94b1c3ed-b004-4698-b229-bfd1dfa6666e",
    ICONS.L0_ICONS.get(4),
  ],
  [
    "Legal Information",
    "e34ebd2f-cd96-22ac-3059-952a7fe01e54",
    "03f463d0-0aa8-4e11-b975-e663307cdb1e",
    ICONS.L0_ICONS.get(6),
  ],
  [
    "HR Information",
    "707babad-231f-82bb-014c-8506d3dc784e",
    "fe71b407-0864-4c40-afb5-16bf6c55ca65",
    ICONS.L0_ICONS.get(5),
  ],
  [
    "Governance Information",
    "2ef1d9da-0ad7-450e-4b09-efd43581ce78",
    "ca6efcc7-1134-4bc1-a0f6-0ea8efd5d247",
    ICONS.L0_ICONS.get(2),
  ],
  [
    "Business Information",
    "e2bd11ab-9869-5adc-f11c-7d05c7c6fc2b",
    "e5d18fd1-ade2-45c0-b5a0-40874bb8d6c3",
    ICONS.L0_ICONS.get(3),
  ],
  [
    "Personal Information",
    "a9383d32-7694-4d84-b37c-79afb945505b",
    "16e67a29-ffc2-4590-bad9-18687431b684",
    ICONS.L0_ICONS.get(7),
  ],
  [
    "Administrators Information",
    "388bf304-4603-4980-9d61-f87096305d1b",
    "388bf304-4603-4980-9d61-f87096305d1b",
    "Admin",
  ],
  [
    "Any Information",
    "03ebd63b-6065-42d6-876e-d27890000ad4",
    "03ebd63b-6065-42d6-876e-d27890000ad4",
    "Other",
  ],
].map(([name, l0_id, id, icon]) => ({ name, l0_id, id, icon }));

const gen_obj = () =>
  info_types_categories.map((item) => {
    return {
      ...item,
      amount: Math.floor(Math.random() * 20),
    };
  });

const ALL_USERS = {
  unprotected: gen_obj(),
  unprotected_ghost: gen_obj(),
  ghost: gen_obj(),
};

// @ts-ignore
export const unprotected_mfa_accounts: Record<
  Partial<RestCallsKey>,
  MockRestCall
> = {
  "accounts-counters": {
    delay: 1000,
    payload: async () => {
      const { SharedState } = await import("@/common/state");

      /* SharedState.l0InfoTypes.value
          .filter((l0) => l0.id !== SharedState.default_label_id.value)
          .map((l0) => {
            return {
              id: l0.id,
              l0_id: l0.id,
              amount: Math.floor(Math.random() * 100),
            };
          }); */
      return ALL_USERS;
    },
  },
  "features.unprotected-mfa-users.get-list": {
    delay: 1000,
    // @ts-ignore
    payload: async ({ info_type }) => {
      const { SharedState } = await import("@/common/state");
      const shuffeld = Object.entries(SharedState.employees_full_objects.value)
        .map(([id, emp]) => {
          return [
            id,
            {
              ...emp,
              rand: Math.random() * 20000,
            },
          ];
        })
        //@ts-ignore
        .sort((a, b) => a[1].rand - b[1].rand);
      const last_index = ALL_USERS.unprotected.find((f) => f.id === info_type)
        ?.amount;
      return {
        cursor: "",
        objects: shuffeld
          .slice(0, last_index)
          // @ts-ignore
          .map(([id, { dep_id, dep_name, email, name }]) => {
            return {
              id: id,
              name: name,
              email: email,
              department: dep_name,
            };
          }),
      };
    },
  },
  "features.ghost-users.get-list": {
    delay: 1000,
    payload: async (payload: { min_days: number; info_type: string }) => {
      const { SharedState } = await import("@/common/state");
      const last_index = ALL_USERS.ghost.find((f) => f.id === payload.info_type)
        ?.amount;
      if (users) {
        return {
          cursor: "",
          objects: users
            .filter((u) => u.ghosting_days >= payload.min_days)
            .slice(0, last_index),
        };
      } else {
        users = Object.entries(SharedState.employees_full_objects.value)
          .slice(0, 200)
          .map(([id, { dep_id, dep_name, email, name }]) => {
            return {
              id: id,
              name: name,
              email: email,
              department: dep_name,
              ghosting_days: rand_floor(116),
            };
          })
          .sort((a, b) => b.ghosting_days - a.ghosting_days);

        return {
          cursor: "",
          objects: users
            .filter((u) => u.ghosting_days >= payload.min_days)
            .slice(0, last_index),
        };
      }
    },
  },
  "features.ghost-unprotected-users.get-list": {
    delay: 1000,
    payload: async (payload: { min_days: number; info_type: string }) => {
      const { SharedState } = await import("@/common/state");
      const last_index = ALL_USERS.unprotected_ghost.find(
        (f) => f.id === payload.info_type
      )?.amount;
      if (users) {
        return {
          cursor: "",
          objects: users
            .filter(
              (u) => u.is_unprotected && u.ghosting_days >= payload.min_days
            )
            .slice(0, last_index),
        };
      } else {
        users = Object.entries(SharedState.employees_full_objects.value)
          .slice(0, 200)
          .map(([id, { dep_id, dep_name, email, name }]) => {
            return {
              id: id,
              name: name,
              email: email,
              is_unprotected: rand_floor(100) < 50,
              department: dep_name,
              ghosting_days: rand_floor(116),
            };
          })
          .sort((a, b) => b.ghosting_days - a.ghosting_days);
        return {
          cursor: "",
          objects: users
            .filter(
              (u) => u.is_unprotected && u.ghosting_days >= payload.min_days
            )
            .slice(0, last_index),
        };
      }
    },
  },
};

// @ts-ignore
export const unprotected_account_user_stats: Record<
  Partial<GqlCallsKey>,
  GqlMockCall
> = {
  "unprotected-accounts.user-stats": {
    delay: 1000,
    payload: async (labels: string[]) => {
      return {
        from_entities: 20,
        to_entities: 30,
      };
    },
  },
};
